import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IStaff } from 'app/models/user/staff';
import { IInHomeCareChange } from 'app/models/licenses/in-home-care/in-home-care-change';

@Injectable({providedIn: 'root'})
export class InHomeCareChangeService {
  public api: string = environment.privateApi + 'InHomeCareChange/';

  public http = inject(HttpClient);

  public getAllChanges(includeApproved: boolean, includeDenied: boolean): Observable<IInHomeCareChange[]>{
    return this.http.get<IInHomeCareChange[]>(this.api + 'GetAllChanges/' + includeApproved + '/' + includeDenied);
  }

  public getAssignedChanges(): Observable<IInHomeCareChange[]> {
    return this.http.get<IInHomeCareChange[]>(this.api + 'GetAssignedChanges');
  }

  public getChangesByLicenseId(licenseId: number): Observable<IInHomeCareChange[]>{
    return this.http.get<IInHomeCareChange[]>(this.api + 'GetChangesByLicense/' + licenseId);
  }

  public approveChange(changeId: number, approved: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ApproveChange/' + changeId + '/' + approved, null);
  }

  public createChange(change: IInHomeCareChange): Observable<IInHomeCareChange>{
    return this.http.post<IInHomeCareChange>(this.api + 'CreateChange', change);
  }

  public getChanges(licenseId: number): Observable<IInHomeCareChange[]>{
    return this.http.get<IInHomeCareChange[]>(this.api + 'GetChanges/' + licenseId);
  }

  public getOwnerChange(licenseId: string): Observable<IInHomeCareChange>{
    return this.http.get<IInHomeCareChange>(this.api + 'GetOwnerChange/' + licenseId);
  }

  public updateChange(change: IInHomeCareChange): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateChange', change);
  }

  public submitChange(change: IInHomeCareChange): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'SubmitChange', change);
  }

  public deleteChange(changeId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteChange/' + changeId);
  }

  public getStaff(licenseType: string): Observable<IStaff[]> {
    return this.http.get<IStaff[]>(this.api + 'GetStaff/' + licenseType);
  }

  public assignChange(changeId: number, staff: IStaff): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'AssignChange/' + changeId, staff);
  }
}
